import React__default from 'react';
import Text from '../text/text.esm.js';

var getInitials = function getInitials(firstInitial, lastInitial) {
  var _firstInitial$0$toUpp, _firstInitial$, _lastInitial$0$toUppe, _lastInitial$;
  var extractFirstInitial = (_firstInitial$0$toUpp = firstInitial === null || firstInitial === void 0 || (_firstInitial$ = firstInitial[0]) === null || _firstInitial$ === void 0 ? void 0 : _firstInitial$.toUpperCase()) !== null && _firstInitial$0$toUpp !== void 0 ? _firstInitial$0$toUpp : '';
  var extractLastInitial = (_lastInitial$0$toUppe = lastInitial === null || lastInitial === void 0 || (_lastInitial$ = lastInitial[0]) === null || _lastInitial$ === void 0 ? void 0 : _lastInitial$.toUpperCase()) !== null && _lastInitial$0$toUppe !== void 0 ? _lastInitial$0$toUppe : '';
  return "".concat(extractFirstInitial).concat(extractLastInitial);
};
var Initials = function Initials(props) {
  var firstInitial = props.firstInitial,
    lastInitial = props.lastInitial;
  var initials = getInitials(firstInitial, lastInitial);
  return /*#__PURE__*/React__default.createElement(Text, {
    className: "csg-tw-initials text-neutral-strong"
  }, initials);
};
var Initials$1 = Initials;

export { Initials$1 as default, getInitials };
//# sourceMappingURL=initials.esm.js.map
